<template>
    <NuxtLink
        v-if="title && to"
        :to
        class="base-card"
    >
        <BuurtLabel v-if="buurt" class="base-card__label" :buurt />
        <div class="base-card__image">
            <slot name="image">
                <BaseImage
                    v-if="image"
                    sizes="(max-width: 900px) 95vw, 480px"
                    :image
                    :title="image?.title"
                    :width="image?.width"
                    :height="image?.height"
                    hide-caption
                />
                <img v-else src="/placeholders/card-image.jpg" alt="">
            </slot>
        </div>

        <div class="base-card__content">
            <div class="base-card__title">
                <slot name="title">{{ title }}</slot>
            </div>

            <div class="base-card__description" v-html="description" />
        </div>
    </NuxtLink>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        required: true,
        default: null
    },
    to: {
        type: [String, Object],
        required: true,
        default: null
    },
    description: {
        type: String,
        required: false,
        default: null
    },
    image: {
        type: Object,
        required: false,
        default: null
    },
    buurt: {
        type: Object,
        required: false,
        default: null
    }
});
</script>

<style lang="less" src="./BaseCard.less" />
